import React, { useEffect, useRef } from 'react';
import { wechatGenerateScheme } from "../../api";
import './style.scss';

// 香港美酒佳肴巡礼·Club8礼遇 H5 落地页
// 19 张切图从上到下拼接；点第 4 张（_04「免费领取 Club8 银卡会员」按钮）
// → scheme 拉起小程序 q4w8k2nx 专题页
const MINI_PATH = "/pages/subject/q4w8k2nx/q4w8k2nx";

// 19 张切图（宽 750）从上到下拼接，顺序对应桌面切图 _01 → _19
const imgs = [
  "https://staticfile.badazhou.com/20261016/f021fa4c01b82d7b2a19bdfdbf39f78f.jpg", // _01 头图 hero (750×1183)
  "https://staticfile.badazhou.com/20261016/1314fdf6aeb4e7e8ecdd1d1e9efb5685.jpg", // _02 (750×574)
  "https://staticfile.badazhou.com/20261016/8ef0cb1e09db52f114512952798c85cd.jpg", // _03 嘉宾礼包详情 (750×649)
  "https://staticfile.badazhou.com/20261016/f08a4ca641b7fe18d4cf7741c815054d.jpg", // _04 ★按钮「免费领取 Club8 银卡会员」(750×114)
  "https://staticfile.badazhou.com/20261016/3a212f5ccda7b5b66a521c95c4f4b120.jpg", // _05 (750×383)
  "https://staticfile.badazhou.com/20261016/6215668a7a9895f5582cc5c6da655676.jpg", // _06 (750×527)
  "https://staticfile.badazhou.com/20261016/53a15713060c63d2acb1cc723966969e.jpg", // _07 (750×537)
  "https://staticfile.badazhou.com/20261016/a6d109adee928bc4d89cb5b8d2a561d0.jpg", // _08 (750×528)
  "https://staticfile.badazhou.com/20261016/3dacb71d2396e8878be332a1f3e1891b.jpg", // _09 (750×539)
  "https://staticfile.badazhou.com/20261016/e3cd9fabe8f30e447b3d47fbf2bc9689.jpg", // _10 (750×533)
  "https://staticfile.badazhou.com/20261016/e5e4a9ce6ecedccf0e75f03aab998322.jpg", // _11 (750×536)
  "https://staticfile.badazhou.com/20261016/d2a45b4c2eea730c9000be4437e74cfc.jpg", // _12 (750×543)
  "https://staticfile.badazhou.com/20261016/f8dcbe01c95577f043cc083c18688442.jpg", // _13 (750×538)
  "https://staticfile.badazhou.com/20261016/18d4254871102d2e88160a9389fe938f.jpg", // _14 (750×538)
  "https://staticfile.badazhou.com/20261016/99950f2a0c03074d5abff871bb7d7756.jpg", // _15 (750×546)
  "https://staticfile.badazhou.com/20261016/9482eaeb6c16736ad325c346d3f637c0.jpg", // _16 (750×537)
  "https://staticfile.badazhou.com/20261016/3171b462332a3e062699b8bc9b3c4f4b.jpg", // _17 JW万豪产品卡 (750×565)
  "https://staticfile.badazhou.com/20261016/c35f12a848d39b08f8381350797f6cb4.jpg", // _18 分节标题「维港奢味」(750×198)
  "https://staticfile.badazhou.com/20261016/8dd2e1662f844a76678aef94afbb7995.jpg", // _19 3晚4天产品卡 (750×569)
];

const BTN_INDEX = 3; // 「免费领取 Club8 银卡会员」按钮所在切图下标（第 4 张 _04）

const Wd8k3n7q = () => {
  const schemeRef = useRef();

  useEffect(() => {
    // 提前生成跳小程序的 URL Scheme
    const randomNum = parseInt(Math.random() * 100000000, 10);
    wechatGenerateScheme({ path: MINI_PATH, query: `randomNum=${randomNum}` })
      .then((res) => { schemeRef.current = res.data; })
      .catch(() => {});
  }, []);

  const goToWxApp = () => {
    const scheme = schemeRef.current && schemeRef.current.scheme;
    if (scheme) {
      window.location.href = scheme;
    }
  };

  return (
    <div className="wd-container">
      {imgs.map((src, i) => (
        <img
          key={i}
          className="wd-img"
          src={src}
          alt=""
          onClick={i === BTN_INDEX ? goToWxApp : undefined}
          style={i === BTN_INDEX ? { cursor: 'pointer' } : undefined}
        />
      ))}
    </div>
  );
};

export default Wd8k3n7q;
